import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';

@Component({
  selector: 'app-custom-button',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './custom-button.component.html',
  styleUrl: './custom-button.component.css'
})
export class CustomButtonComponent implements OnInit {
  @Input() buttonText: string = '';
  @Input() isDisabled: boolean = false;
  @Output() buttonClick = new EventEmitter<void>();

  // Color inputs
  @Input() backgroundColor: string = 'bg-white';
  @Input() textColor: string = 'text-black';
  @Input() borderColor: string = 'border-border';

  @Input() showSpinner: boolean = false;

  @Input() hoverBackgroundColor: string = 'hover:bg-primary';
  @Input() hoverTextColor: string = 'hover:text-white';
  @Input() hoverBorderColor: string = 'hover:border-primary';

  @Input() disabledBackgroundColor: string = 'bg-neutral-800';
  @Input() disabledTextColor: string = 'text-neutral-300';
  @Input() disabledBorderColor: string = 'border-neutral-300';

  @Input() fontWeight: string = 'font-medium';

  // Icons input
  @Input() leadingIcon: string | null = null;
  @Input() leadingIconAlt: string = '';

  @Input() trailingIcon: string | null = null;
  @Input() trailingIconAlt: string = '';

  @Input() title: string = '';
  @Input() disabledTitle: string | null = null;

  constructor(private translocoService: TranslocoService) { }

  ngOnInit(): void {
    if (!this.leadingIconAlt) {
      this.translocoService
        .selectTranslate('shared.icon')
        .subscribe((translation) => {
          this.leadingIconAlt = translation;
        });
    }

    if (!this.trailingIconAlt) {
      this.translocoService
        .selectTranslate('shared.icon')
        .subscribe((translation) => {
          this.trailingIconAlt = translation;
        });
    }
  }

  onClick() {
    if (!this.isDisabled) {
      this.buttonClick.emit();
    }
  }

}
